import { useEffect, useState } from "react";

import { useEditorFocus, useRemirrorContext } from "@remirror/react";

import { FocusContext } from "./FocusContext";

export const FocusProvider = ({ children }: { children: React.ReactNode }) => {
  const context = useRemirrorContext();
  const [isDirectlyFocused] = useEditorFocus();
  const [isPopupOrModalFocused, setPopupOrModalFocused] = useState(false);
  const [lastActiveEditor, setLastActiveEditor] = useState<HTMLElement | null>(
    null,
  );

  useEffect(() => {
    const modalMount = document.getElementById("semantic-modal-mount-node");
    if (!modalMount) {
      return;
    }

    const focusChangeHandler = (e: FocusEvent) => {
      if (
        e.target instanceof HTMLElement &&
        e.target.classList.contains("remirror-editor")
      ) {
        setLastActiveEditor(e.target);
      } else {
        const isTargetInModal = modalMount.contains(e.target as Node);
        setPopupOrModalFocused(isTargetInModal);
      }
    };

    document.addEventListener("focus", focusChangeHandler, true);
    return () => {
      document.removeEventListener("focus", focusChangeHandler, true);
    };
  }, []);

  const isFocused =
    isDirectlyFocused ||
    (isPopupOrModalFocused && lastActiveEditor === context.view.dom);

  return (
    <FocusContext.Provider
      value={{ isFocused, isDirectlyFocused, isPopupOrModalFocused }}
    >
      {children}
    </FocusContext.Provider>
  );
};
